<template>
    <div class="container-action-button">
        <BaseButton @click="onEditNomenclatureType" buttonText="" title="Modifier">
            <template v-slot:iconBefore>
                <font-awesome-icon :icon="['fas', 'pen']" />
            </template>
        </BaseButton>
        <BaseButton @click="onCopyNomenclatureType" buttonText="" title="Copier">
            <template v-slot:iconBefore>
                <font-awesome-icon :icon="['fas', 'copy']" />
            </template>
        </BaseButton>
        <BaseButton @click="onOpenDocumentLink" buttonText="" title="Documents">
            <template v-slot:iconBefore>
                DO
            </template>
        </BaseButton>
    </div>
</template>

<script>
    import BaseButton from '../../components/Base/BaseButton.vue';
    import * as Vue from "vue";
    import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

    export default {
        name: 'ListNomenclatureTypeTypesActionButtonsRenderer',
        components: {
            BaseButton: Vue.shallowRef(BaseButton),
            FontAwesomeIcon: Vue.shallowRef(FontAwesomeIcon)
        },
        methods: {
            onEditNomenclatureType() {
                this.params.context.componentParent.displayEditNomenclatureTypeModal(this.params.data);
            },
            onCopyNomenclatureType() {
                this.params.context.componentParent.displayCopyNomenclatureTypeModal(this.params.data);
            },
            onOpenDocumentLink() {
                this.params.context.componentParent.openDocumentLink(this.params.data);
            }
        }
    }        
</script>